import React from 'react';
import toCurrency from '../../../../util/toCurrency';
import Styles from './styles';

export default ({ originalInterest = 0, newInterest = 0 }) => (
  <Styles>
    <li>
      <section className='label'>
        <h4 className='type-label-large color-grey1 no-margin-top margin-bottom-1'>
          Original Interest
        </h4>
        <h5 className='type-h4 no-margin-top no-margin-bottom'>
          {toCurrency(originalInterest)}
        </h5>
      </section>
      <section className='bar'>
        <div className='fill' />
      </section>
    </li>
    <li>
      <section className='label'>
        <h4 className='type-label-large color-grey1 no-margin-top margin-bottom-1'>
          New Interest
        </h4>
        <h5 className='type-h4 no-margin-top no-margin-bottom'>
          {toCurrency(newInterest)}
        </h5>
      </section>
      <section className='bar new'>
        <div
          className='fill'
          style={{ width: `${(newInterest / originalInterest) * 100}%` }}
        />
      </section>
    </li>
  </Styles>
);
